import React, { useEffect, useMemo, useRef, useState } from "react";
import { Col, Tooltip, notification, theme } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  CheckOutlined,
  FullscreenOutlined,
  MoonFilled,
  SearchOutlined,
  SunFilled,
} from "@ant-design/icons";
import SimpleTable from "../../pages/MarketWatch/SimpleTable/SimpleTable";
import ThemeInput from "../../components/ThemeInput";
import {
  newSelectedMarket,
  setColumnFilter,
  setSeletedMarket,
  setWatchListArray,
} from "../../store/slice/marketWatchSlice";
import dayjs from "dayjs";
import EndPoints from "../../APICall/EndPoints";
import APICall from "../../APICall";
import { useQuery } from "@tanstack/react-query";
import { useSocket } from "../../components/Socket";
import {
  StyledTableWrapper,
  StyledDropDownItem,
  StyledMarketButtonAll,
  StyledMarketButton,
  SearchColumn,
  SettingIcon,
  MarketWatchFilterColumns,
  WatchListRow,
} from "./style";
import HeaderView from "./Components/HeaderView";
import DropdownWatchList from "./Components/DropdownWatchList";
import WatchListModal from "./Components/WatchListModal";
import DisconnectedModal from "../../components/Modal";
import { setScriptCall } from "../../store/slice/globleSlice";
import TableFilterModal from "../../components/TableFilterModal/TableFilterModal";

var customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);

function MarketWatch() {
  const fullscreenRef = useRef(null);
  const dispatch = useDispatch();
  //state
  // const [selectedMarket, setSelectedMarket] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [showColumnFilter, setShowColumnFilter] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState({
    flage: false,
    index: null,
  });
  const [watchListModal, setWatchListModal] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const socketContext = useSocket();
  const { doSend } = socketContext;

  //redux
  // const marketList = useSelector((state) => state.globleSlice.marketListData);
  // const visibleList = useSelector(
  //   (state) => state.marketWatchSlice.selectedMarket
  // );
  const watchList = useSelector(
    (state) => state?.marketWatchSlice?.watchListArray
  );
  const selectedMarket =
    useSelector((state) => state.marketWatchSlice?.seletctedMaketIndex) || 0;
  const webSocketConnection = useSelector(
    (state) => state?.webSocketSlice?.webSocket?.socket
  );
  const userDetails = useSelector((state) => state.authSlice?.userDetail);
  const loginUserId = userDetails?.userId;
  const isCustomer = userDetails?.accountType === "customer";
  const checkList = useSelector(
    (state) => state.marketWatchSlice?.columnCheckList
  );
  const unsubscribeSymbol = useMemo(() => {
    return watchList?.[selectedMarket]?.scriptList?.map((el) => el?.symbol);
  }, [watchList, selectedMarket]);

  const getWatchList = async () => {
    let response = await APICall("get", EndPoints.getWatchList);
    return response.data?.data;
  };

  // api call
  const {
    isLoading: watchListLoading,
    data: watchListData,
    error: watchListError,
  } = useQuery({
    queryKey: ["getWatchList"],
    queryFn: getWatchList,
    refetchOnMount: true,
  });

  const getPositions = async (obj) => {
    let payloadObj = {
      userId: Number(loginUserId),
    };

    let response = await APICall("post", EndPoints?.tradePosition, payloadObj);
    return response?.data?.data;
  };

  if (watchListError) notification.error({ message: watchListError?.message });

  const {
    isLoading: positionLoading,
    data: positionData,
    error: positionError,
  } = useQuery({
    queryKey: ["getPositionData"],
    queryFn: getPositions,
    refetchOnMount: true,
  });

  const handleFullscreenChange = () => {
    setIsFullScreen(!!document.fullscreenElement);
  };

  // life cycle
  useEffect(() => {
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      doSend({
        event: "unsubscribeToServerMarket",
        payload: unsubscribeSymbol,
      });
      dispatch(setScriptCall([]));
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  useEffect(() => {
    if (
      (!selectedMarket && selectedMarket !== 0) ||
      selectedMarket >= watchList?.length
    ) {
      dispatch(setSeletedMarket(0));
    }
  }, [selectedMarket]);

  useEffect(() => {
    const symbolCall = watchListData?.[selectedMarket]?.scriptList?.map(
      (el) => el?.symbol
    );
    if (symbolCall?.length > 0) {
      doSend({
        event: "subscribeToServerMarket",
        payload: symbolCall,
      });
    }
    dispatch(setScriptCall(symbolCall));
  }, [selectedMarket, watchListData]);

  useEffect(() => {
    if (watchListData) {
      let isDiff = compareArrays(watchList, watchListData);
      if (isDiff) {
        dispatch(setWatchListArray({ data: watchListData, type: "new" }));
      }
      // getWatchListByHook(watchListData);
    }
  }, [watchListData, positionData]);

  useEffect(() => {
    if (positionData?.length > 0) {
      let positionsymbol = positionData?.map((el) => el?.symbol);
      const newWatchlistData = watchListData?.map((el) => {
        let scriptList = el?.scriptList?.map((script) => {
          let validPosition = positionsymbol?.includes(script?.symbol);
          if (validPosition) {
            let newPosition = positionData?.filter(
              (item) => item?.symbol === script?.symbol
            );
            return { ...script, positions: newPosition };
          } else {
            return { ...script };
          }
        });
        return { ...el, scriptList };
      });

      dispatch(setWatchListArray({ data: newWatchlistData, type: "new" }));
    }
  }, [positionData, watchListData]);

  //functions
  const handleScriptSearch = (e) => {
    setSearchValue(e?.target?.value);
  };

  const handleMarketButton = (index) => {
    let removeSymbol = watchList?.[selectedMarket]?.scriptList?.map(
      (el) => el?.symbol
    );
    if (removeSymbol?.length > 0) {
      doSend({
        event: "unsubscribeToServerMarket",
        payload: removeSymbol,
      });
    }

    dispatch(setSeletedMarket(index));

    // setDropdownOpen({ flage: false, index: null });
  };

  const showAllTables = () => {
    // setSelectedMarket("All");
  };

  const onClickFullScreen = async () => {
    fullscreenRef.current.requestFullscreen();
  };

  const handleOpenChange = (open, index) => {
    setDropdownOpen({ flage: open, index: index });
  };

  const handleThemeChange = (value) => {
    const isDark = checkList?.includes("theme");
    if (isDark) {
      dispatch(setColumnFilter(checkList?.filter((el) => el !== "theme")));
    } else {
      dispatch(setColumnFilter([...checkList, "theme"]));
    }
    // if (value) {
    //   dispatch(setColumnFilter([...checkList, "theme"]));
    // } else {
    //   dispatch(setColumnFilter(checkList?.filter((el) => el !== "theme")));
    // }
  };

  return (
    <>
      <div style={{ 
        backgroundColor: 'var(--bg-primary)', 
        minHeight: '100vh',
        padding: '1rem'
      }}>
        <HeaderView positionData={positionData} />

        <StyledTableWrapper ref={fullscreenRef} isFullScreen={isFullScreen}>
          <>
            {/* <Row
            justify={window.innerWidth >= "1200px" ? "space-between" : "left"}
            gutter={[10, 10]}
            style={{
              width: "100%",
              marginTop: "2.5rem",
              height: "fit-content",
            }}
          >
            <Col xs={12} sm={8} md={6} lg={3} xl={2}>
              <StyledMarketButtonAll
                $isSelected={selectedMarket === "All"}
                dropdownRender={() => <DropdownRender />}
                onClick={showAllTables}
              >
                All
              </StyledMarketButtonAll>
            </Col>

            {marketList.length !== 0 &&
              marketList?.map((item, index) => {
                return (
                  <Col xs={12} sm={8} md={6} lg={3} xl={2} key={item.value}>
                    <StyledMarketButton
                      $isSelected={selectedMarket === item}
                      onClick={() => handleMarketButton(item)}
                    >
                      {item.label}
                    </StyledMarketButton>
                  </Col>
                );
              })}

            <Col
              xs={12}
              sm={12}
              md={12}
              lg={6}
              xl={4}
              style={{
                marginLeft: window.innerWidth >= 1200 ? "auto" : "",
              }}
            >
              <ThemeInput
                required
                inputProps={{
                  placeholder: "Search anything here",
                  prefix: <SearchOutlined />,
                  onChange: handleScriptSearch,
                }}
                formProps={{
                  name: "search_text",
                }}
              />
            </Col>

            {
              <Col
                xs={24}
                sm={12}
                md={6}
                lg={15}
                xl={1}
                style={{ textAlign: "end" }}
              >
                <Tooltip title="Full screen">
                  <FullscreenOutlined
                    onClick={onClickFullScreen}
                    style={{
                      height: "3.5rem",
                      cursor: "pointer",
                    }}
                  />
                </Tooltip>
              </Col>
            }
          </Row> */}
          </>

          <WatchListRow align={"middle"} gutter={[10, 10]}>
            {watchList &&
              watchList?.map((item, index) => {
                return (
                  <Col key={index} xs={11} sm={7} md={6} lg={3} xl={2}>
                    <StyledMarketButtonAll
                      trigger={["hover", "click"]}
                      $isSelected={selectedMarket == index}
                      onClick={() => handleMarketButton(index)}
                      dropdownRender={() => (
                        <DropdownWatchList
                          item={item}
                          index={index}
                          setDropdownOpen={setDropdownOpen}
                          dropdownOpen={dropdownOpen}
                        />
                      )}
                      open={dropdownOpen?.flage && dropdownOpen?.index == index}
                      onOpenChange={(value) => handleOpenChange(value, index)}
                    >
                      {item?.name}
                    </StyledMarketButtonAll>
                    {/* <StyledDropDown
                    menu={{
                      items,
                    }}
                    placement="bottom"
                    arrow={{
                      pointAtCenter: true,
                    }}
                  >
                    <StyledMarketButton>bottom</StyledMarketButton>
                  </StyledDropDown> */}
                  </Col>
                );
              })}
            <Col xs={11} sm={7} md={6} lg={3} xl={3}>
              <StyledMarketButton onClick={() => setWatchListModal(true)}>
                + Add Watch-List
              </StyledMarketButton>
            </Col>
            <SearchColumn xs={24} sm={12} md={12} lg={8} xl={5}>
              {/* <ThemeSwitch
                defaultChecked={checkList?.includes("theme")}
                checkedChildren="Dark"
                unCheckedChildren="Light"
                onChange={handleThemeChange}
              /> */}
              {/* <StyledSwitch
                checked={checkList?.includes("theme")}
                onChange={handleThemeChange}
                isDarkMode={checkList?.includes("theme")}
                className={
                  checkList?.includes("theme") ? "dark-mode" : "light-mode"
                }
              /> */}
              <Tooltip
                title={
                  checkList?.includes("theme") ? "Dark Mode" : "Light Mode"
                }
                placement="top"
              >
                {checkList?.includes("theme") ? (
                  <MoonFilled
                    onClick={handleThemeChange}
                    style={{ fontSize: "1.5rem" }}
                  />
                ) : (
                  <SunFilled
                    onClick={handleThemeChange}
                    style={{
                      fontSize: "1.5rem",
                      color: "#abab38",
                    }}
                  />
                )}
              </Tooltip>
              <SettingIcon onClick={() => setShowColumnFilter(true)} />
              <ThemeInput
                required
                inputProps={{
                  placeholder: "Search anything here",
                  prefix: <SearchOutlined />,
                  onChange: handleScriptSearch,
                }}
                marginBottom="0px"
              />
              <Tooltip title="Full screen">
                <FullscreenOutlined
                  onClick={onClickFullScreen}
                  style={{ height: "3.5rem", cursor: "pointer" }}
                />
              </Tooltip>
            </SearchColumn>
          </WatchListRow>

          {watchListModal && (
            <WatchListModal
              watchListModal={watchListModal}
              setWatchListModal={setWatchListModal}
            />
          )}
          {/* {selectedMarket === "All" ? (
            watchList.length !== 0 &&
            watchList?.map((item) => {
              if (!visibleList?.[item.value]) {
                return null;
              }
              return (
                <SimpleTable
                  key={item.name}
                  title={item.name}
                  searchValue={searchValue}
                  isLoading={watchListLoading}
                  watchListData={item?.scriptList}
                />
              );
            })
            <SimpleTable
              key={selectedMarket}
              title={watchList?.[selectedMarket]?.name}
              searchValue={searchValue}
              isLoading={watchListLoading}
              selectedMarket={selectedMarket}
              watchListData={watchList?.[selectedMarket]?.scriptList}
            />
          ) : ( */}

          <SimpleTable
            key={selectedMarket}
            title={watchList?.[selectedMarket]?.name}
            searchValue={searchValue}
            isLoading={watchListLoading}
            selectedMarket={selectedMarket}
            watchListData={watchList?.[selectedMarket]?.scriptList}
            positionData={positionData}
            checkList={checkList}
          />
        </StyledTableWrapper>
      </div>
      <DisconnectedModal isOpen={!webSocketConnection} />
      {showColumnFilter && (
        <TableFilterModal
          column={MarketWatchFilterColumns}
          setShowFilter={setShowColumnFilter}
          checkList={checkList}
          filtertype="marketWatch"
        />
      )}
    </>
  );
}

export default MarketWatch;

function compareArrays(array1, array2) {
  if (array1?.length !== array2?.length) return true;

  for (let i = 0; i < array1?.length; i++) {
    const item1 = array1[i];
    const item2 = array2[i];

    // Find corresponding items by _id
    if (item1?._id !== item2?._id) return true;

    const scriptList1 = item1?.scriptList || [];
    const scriptList2 = item2?.scriptList || [];

    // Compare scriptList lengths
    if (scriptList1?.length !== scriptList2?.length) return true;

    // Create sets of symbols from both lists
    const symbols1 = new Set(scriptList1.map((script) => script.symbol));
    const symbols2 = new Set(scriptList2.map((script) => script.symbol));

    // If sets have different sizes, they can't be equal
    if (symbols1.size !== symbols2.size) return true;

    // Check if all symbols from list1 are in list2
    for (let symbol of symbols1) {
      if (!symbols2.has(symbol)) return true;
    }
  }

  return false; // No differences found in symbols
}

const DropdownRender = (menu) => {
  const token = theme.useToken().token;
  const dispatch = useDispatch();

  // redux
  const marketList = useSelector((state) => state.globleSlice.marketListData);
  const selectedlist = useSelector(
    (state) => state.marketWatchSlice.selectedMarket
  );

  // function
  const onClickMarketItem = (item) => {
    let obj = {
      ...selectedlist,
      [item.value]: !selectedlist[item.value],
    };

    dispatch(newSelectedMarket(obj));
  };

  return (
    <div
      style={{
        backgroundColor: token.colorBgElevated,
        borderRadius: token.borderRadiusLG,
        boxShadow: token.boxShadowSecondary,
        paddingBlock: "0.5rem",
      }}
    >
      {marketList?.map((item, index) => {
        const selected = selectedlist?.[item.value];
        return (
          <StyledDropDownItem
            $selected={selected}
            onClick={() => onClickMarketItem(item)}
            key={item?.value}
          >
            <CheckOutlined
              style={{
                marginRight: "0.5rem",
                visibility: selected ? "visible" : "hidden",
              }}
            />
            {item?.label}
          </StyledDropDownItem>
        );
      })}
    </div>
  );
};
